import { ModuleSpec } from '../types';
import { Icon, id, label, route } from './config';
import menuItem from './MenuItem';
import routes from './routes';

export { Icon, route } from './config';
export * from './types';

const patientenModule: ModuleSpec = {
  id,
  label,
  icon: Icon,
  enabled: (license) => license.module.includes('patienten'),
  dataProviders: [],
  menuItem,
  supportsMissions: true,
  trackingContext: 'Patienten',
  route,
  routes,
  dashboardTiles: [{ label, to: route, icon: Icon }],
};

export default patientenModule;
